import { render, staticRenderFns } from "./TabListOverview.vue?vue&type=template&id=5cfb5136&scoped=true"
import script from "./TabListOverview.vue?vue&type=script&lang=js"
export * from "./TabListOverview.vue?vue&type=script&lang=js"
import style0 from "./TabListOverview.vue?vue&type=style&index=0&id=5cfb5136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfb5136",
  null
  
)

export default component.exports